export enum PaymentLevel {
  HOURLY = 'HOURLY',
  SALARY = 'SALARY',
  STIPEND = 'STIPEND',
}

export const PAYMENT_LEVELS = Object.defineProperties(
  {},
  {
    HOURLY: { get: () => getText('Hourly'), enumerable: true },
    SALARY: { get: () => getText('Salary'), enumerable: true },
    STIPEND: { get: () => getText('Stipend'), enumerable: true },
  },
) as Record<PaymentLevel, string>;

export const PAYMENT_LEVEL_RADIO_OR_SELECT_OPTIONS = () =>
  Object.entries(PAYMENT_LEVELS)
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key as keyof typeof PAYMENT_LEVELS,
      label: value,
    }));

export const PAYMENT_LEVEL_CHECKBOX_OPTIONS = () =>
  Object.entries(PAYMENT_LEVELS)
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key as keyof typeof PAYMENT_LEVELS,
      label: value,
    }));
